// 이벤트 CSV 업로드 양식. key 는 event_master 컬럼명, desc 는 양식/모달에 표시되는 설명이다.
export const EVENT_CSV_COLUMNS = [
    {key: 'seq', desc: '비워두면 신규 등록 / 값이 있으면 해당 행 수정'},
    {key: 'typeIndex', desc: '이벤트 인덱스. Event_Setting.csv 에 있는 index 만 사용 가능'},
    {key: 'eventType', desc: '이벤트 종류. 비워두면 Event_Setting.csv 값으로 채워짐 (기간 중복 검사 기준)'},
    {key: 'begin', desc: '시작 일시. YYYY-MM-DD HH:mm:ss 또는 unix(초)'},
    {key: 'end', desc: '종료 일시. YYYY-MM-DD HH:mm:ss 또는 unix(초)'},
    {key: 'onOff', desc: '활성 여부. 1=On / 0=Off'},
    {key: 'operationType', desc: '운영 타입. 1=기간 내 / 2=월 단위 / 3=주 단위 / 4=일 단위 / 5=선행 조건 발동(깜짝 이벤트 전용)'},
    {key: 'onTime', desc: '시작 날짜. 주 단위는 요일(0=일 ~ 6=토) / 월 단위는 일(1~31) / 그 외는 1 이상. 기본 1'},
    {key: 'startTime', desc: '시작 시간(자정부터 분). 예) 09:00 이면 540'},
    {key: 'arrived', desc: '운영 기간(분). 1 이상, 예) 1일이면 1440'},
    {key: 'openLevel', desc: '참여 가능 최소 계정 레벨. 1 이상, 비워두면 Event_Setting.csv 값'},
    {key: 'maxLevel', desc: '참여 가능 최대 계정 레벨. 기본 999'},
    {key: 'loadTableIdx', desc: 'Event_Setting.csv 가 관리. 비워두면 자동으로 채워짐'},
    {key: 'rewardGroup', desc: 'Event_Setting.csv 가 관리. 비워두면 자동으로 채워짐'},
    {key: 'eventIndex', desc: '이벤트 회차. 기본 1'},
    {key: 'itemIdx', desc: '연출 아이템 인덱스. 사용하지 않으면 0'},
    {key: 'itemMultiple', desc: '연출 아이템 배수. 사용하지 않으면 0'},
    {key: 'action', desc: '이벤트 동작 값. 사용하지 않으면 0'},
    {key: 'surpriseTime', desc: '깜짝 이벤트 운영 시간(분). 깜짝 이벤트면 1 이상 필수 입력, 아니면 0'},
    {key: 'cooldownMinutes', desc: '재발동 쿨타임(분). 사용하지 않으면 0'},
    {key: 'dailyMaxCount', desc: '일일 최대 발동 횟수. 제한 없으면 0'},
    {key: 'weekdays', desc: '발동 가능 요일 비트마스크. 일=1,월=2,화=4,수=8,목=16,금=32,토=64 의 합. 매일=127 / 평일=62 / 주말=65. 기본 127'},
    {key: 'triggers', desc: '선행 조건 JSON. 운영 타입 5 일 때만 사용. 예) [{"type":2,"targetId":1,"count":300}]. 쉼표가 들어가므로 큰따옴표로 감싸주세요'},
    {key: 'memo', desc: '운영 메모. 쉼표가 들어가면 큰따옴표로 감싸주세요'},
];
